import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewChecked, ChangeDetectorRef, Injectable, Injector, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { BaseRelService, downloadedFile } from 'src/app/services/base-rel/base-rel.service';
import { tipoAcaoCteItem } from '../gestao-de-cte.model';

export interface Widget {
  id?: string;
  label?: string;
  component: any;
  inputs: any;
  outputs: any;
}

export interface PaginationOptions {
  index: number, size: number, length: number
}

@Injectable({
  providedIn: 'root'
})
export abstract class GestaoDeCteBaseComponent<T> implements OnInit {

  public abstract titulo: string;
  public abstract subtitulo: string;
  public abstract componenteFiltro: Widget;
  public abstract formPesquisa: FormGroup;
  public abstract componenteGrid: Widget;

  public tabIndex: number = 0;
  public arrayAbas: Widget[] = [];

  public isLoading: boolean = false;
  public exibirGrid: boolean = false;
  public paging: PaginationOptions = { index: 0, length: 0, size: 10 };

  public filters: any = {};

  get gridData(): any[] {
    return this.componenteGrid.inputs.gridData;
  }

  set gridData(data: any[]) {
    this.componenteGrid.inputs.gridData = data;
  }

  public featureId;
  public acaoGeral: tipoAcaoCteItem;

  public snackBar: MatSnackBar;
  public route: ActivatedRoute;
  public change: ChangeDetectorRef;

  constructor(
    public injectorObj: Injector,
    public service: BaseRelService
  ) {
    this.snackBar = this.injectorObj.get(MatSnackBar);
    this.route = this.injectorObj.get(ActivatedRoute);
    this.change = this.injectorObj.get(ChangeDetectorRef);

    this.featureId = this.route.snapshot.data['FEATURE_ID'];

    var acaoId = this.route.snapshot.data['tipoAcao'];
    if (acaoId) this.acaoGeral = { id: acaoId, descricao: 'Carregando...' };

    this.isLoading = false;
    this.exibirGrid = false;
  }

  ngOnInit() {

  }

  public setFilterComponent(component,
    inputs = {},
    outputs = {},
    id = null,
    label = null) {
    this.componenteFiltro = {
      id: id,
      label: label,
      component: component,
      inputs: {
        ...inputs,
        parent: this,
        formPesquisa: this.formPesquisa,
      },
      outputs: {
        ...outputs
      }
    };
  }

  public setGridComponent(component,
    inputs = {},
    outputs = {},
    id = null,
    label = null) {
    this.componenteGrid = {
      id: id,
      label: label,
      component: component,
      inputs: {
        ...inputs,
        parent: this
      },
      outputs: outputs
    };
  }

  public setPage(p) {
    this.paging.index = p;
  }

  public carregarGrid(request = null, callback = null) {
    if (!request) request = this.filters;

    this.isLoading = true;
    this.gridData = null;
    this.exibirGrid = true;
    this.paging.index = request.paginaAtual ? request.paginaAtual - 1 : this.paging.index;

    this.changeTabIndex(0);

    this.filters = {
      ...request,
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size
    };
    this.service
      .consultar(this.filters)
      .subscribe(
        (response: any) => {
          this.gridData = response;

          this.exibirGrid = true;
          if (response.length > 0) {
            this.paging.length = response[0].totalCount;
          }

          if (callback) callback(response);
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar(
            "Ocorreu um erro ao consultar! Tente novamente ou, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      )
      .add(() => {
        this.isLoading = false;
      });
  }

  public excel() {
    return this.service.excel(this.filters,
      (response) => this.gerarArquivo(response),
      (err) => console.log(err));
  }

  public clearFields() {
    this.formPesquisa.reset();
    this.arrayAbas = [];
    this.changeTabIndex(0);
    this.exibirGrid = false;
  }

  public addTab(component, inputs, outputs, id, label) {
    let item = this.createWidget(component, { ...inputs }, { ...outputs }, id, label);
    if (!this.checkExistTab(item)) {
      this.arrayAbas.unshift(item);
      this.changeTabIndex(1);
    }
  }

  public openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

  public removerTabItem(item: Widget) {
    let idx = this.arrayAbas.indexOf(item);
    if (idx != -1) this.removerTab(idx);
  }

  public removerTab(index: number, event?: MouseEvent) {
    if (event) event.preventDefault();
    this.arrayAbas.splice(index, 1);
  }

  public checkExistTab(item: Widget) {
    let idx = this.arrayAbas.findIndex((d) => d.id == item.id);
    const exists = idx !== -1;
    if (exists) {
      //atualizar item para receber dados mais recentes
      this.arrayAbas[idx] = item;
      this.changeTabIndex(idx + 1);
    }

    return exists;
  }

  public createWidget(component,
    inputs = {},
    outputs = {},
    id = null,
    label = null) {
    let retorno: Widget = {
      id: id,
      label: label,
      component: component,
      inputs: {
        ...inputs,
        parent: this,
      },
      outputs: {
        ...outputs
      }
    };
    return retorno;
  }

  public changeTabIndex(index) {
    setTimeout(() => {
      this.tabIndex = index;
      this.change.markForCheck();
    });
  }

  public onPageChange(evt: { pageIndex: number; pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.filters.paginaAtual = evt.pageIndex + 1;
    this.filters.itensPorPagina = evt.pageSize;
    this.carregarGrid();
  }

  public tooltipHelp(campo) {
    return `${campo}#${this.featureId}`;
  }

  private gerarArquivo(file: downloadedFile) {
    const url = window.URL.createObjectURL(file.blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", file.filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
